document.addEventListener('DOMContentLoaded', function() {
  // Helper function to get the class that starts with a specific prefix
  function getClassWithPrefix(element, prefix) {
    var classes = Array.from(element.classList);
    return classes.find(function(c) {
      return c.startsWith(prefix);
    });
  }

  // 1. Select all nodes with a class name that starts with 'btn-filter-'
  var buttons = document.querySelectorAll('[class*="btn-filter-"]');

  buttons.forEach(function(button) {
    // 3. Add click event listener to each button
    button.addEventListener('click', function() {
      // **New Code: Remove 'active' class from all buttons and add it to the clicked button**
      buttons.forEach(function(btn) {
        btn.classList.remove('active');
      });
      button.classList.add('active');

      // Get the filter value from the button's class
      var btnClass = getClassWithPrefix(button, 'btn-filter-');
      var filterValue = btnClass.substring('btn-filter-'.length);

      // 2. Find the node with the class name 'filter-contents'
      var filterContents = document.querySelector('.filter-contents');

      // Find all divs within filterContents that have a class starting with 'filter-'
      var divs = filterContents.querySelectorAll('div[class*="filter-"]');

      divs.forEach(function(div) {
        // Get the filter class from the div
        var divClass = getClassWithPrefix(div, 'filter-');
        var divFilterValue = divClass.substring('filter-'.length);

        // Show or hide the div based on the filter value
        if (filterValue === 'all') {
          // Show all divs when 'all' button is clicked
          div.style.display = '';
        } else if (divFilterValue === filterValue) {
          div.style.display = '';
        } else {
          div.style.display = 'none';
        }
      });
    });
  });
}); 